import { InjectionToken, Provider, Type } from '@angular/core';
import { ProvideProductResultComponentConfig } from './ProvideProductResultComponentConfig';
import { STANDARD_PRODUCT_RESULT_VIEW_COMPONENTS, WIRE_CUT_PRODUCT_RESULT_VIEW_COMPONENTS } from '../../types';
import { ProductTypes } from 'products-data';

export function provideProductResultComponent(config: ProvideProductResultComponentConfig): Provider[] {
  let provide: InjectionToken<Type<unknown>[]>;
  switch (config.type) {
    case ProductTypes.Wire:
      provide = WIRE_CUT_PRODUCT_RESULT_VIEW_COMPONENTS;
      break;
    case ProductTypes.Standard:
    default:
      provide = STANDARD_PRODUCT_RESULT_VIEW_COMPONENTS;
      break;
  }
  return [
    {
      provide,
      useValue: config.component,
      multi: true,
    },
  ] as Provider[];
}
